<template>
    <!--                    nav start-->
    <div class="pb-48 reports-nav">
        <router-link v-if="this.customerType === 'O'" :to="`/${$i18n.locale}/reports/invoice-report`"
                     class="reports-nav-item"
                     :class="{ active: $route.path === `/${$i18n.locale}/reports/invoice-report` }">
            {{ $t('nav.main.invoicereport') }}
        </router-link>
        <router-link v-if="this.customerType === 'O'" :to="`/${$i18n.locale}/reports/service-report`"
                     class="reports-nav-item"
                     :class="{ active: $route.path === `/${$i18n.locale}/reports/service-report` }">
            {{ $t('nav.main.servicereport') }}
        </router-link>
        <router-link v-if="this.customerType === 'O'" :to="`/${$i18n.locale}/reports/passenger-report`"
                     class="reports-nav-item"
                     :class="{ active: $route.path === `/${$i18n.locale}/reports/passenger-report` }">
            {{ $t('nav.main.passengerreport') }}
        </router-link>
        <router-link :to="`/${$i18n.locale}/reports/travels-report`" class="reports-nav-item"
                     :class="{ active: $route.path === `/${$i18n.locale}/reports/travels-report` }">
            {{ $t('nav.main.oot') }}
        </router-link>
        <!--eslint-disable-next-line-->
        <!--        <router-link :to="`/${$i18n.locale}/reports/co2-report`" class="reports-nav-item" :class="{ active: $route.path === `/${$i18n.locale}/reports/co2-report` }" v-html="$t('nav.main.co2report')">-->
        <!--        </router-link>-->
        <router-link v-if="this.customerType === 'O'" :to="`/${$i18n.locale}/reports/about`" class="reports-nav-item"
                     :class="{ active: $route.path === `/${$i18n.locale}/reports/about` }">
            Info
        </router-link>
    </div>
    <!--                     nav end-->
</template>

<script lang="ts">
import store from "@/store";
import { Vue } from 'vue-property-decorator'

export default class ReportNavigation extends Vue {
    get customerType(): string {
        return store.getters.getCustomerType
    }
}
</script>

<style scoped>

</style>
